export const API_KEY = "9f690b4231e91ec453419801a3f74c7f";
export const API_PREFIX = "https://api.openweathermap.org";
